var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83441 11.7657C5.52199 11.4533 5.52199 10.9467 5.83441 10.6343L8.46873 8L5.83441 5.36569C5.52199 5.05327 5.52199 4.54673 5.83441 4.23431C6.14683 3.9219 6.65336 3.9219 6.96578 4.23431L10.1658 7.43431C10.4782 7.74673 10.4782 8.25327 10.1658 8.56569L6.96578 11.7657C6.65336 12.0781 6.14683 12.0781 5.83441 11.7657Z",
    fill: "#030C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.11caacd6.svg";
export { ForwardRef as ReactComponent };